(function () {
    'use strict';

    function init() {
        const containers = document.querySelectorAll('.js-awards');
        if (!containers) return;

        containers.forEach((container) => {
            const itemsCount = container.style.getPropertyValue('--items-count');

            setupSwiper('.js-awards-carousel', {
                root: container,
                containerSelector: '.js-awards-carousel-container',
                jsSelector: '.js-awards-carousel',
                swiperOptions: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    breakpoints: {
                        580: { slidesPerView: Math.min(itemsCount, 2) },
                        1024: { slidesPerView: Math.min(itemsCount, 3) },
                        1280: { slidesPerView: Math.min(itemsCount, 4) },
                        1400: { slidesPerView: Math.min(itemsCount, 5) },
                        1600: { slidesPerView: Math.min(itemsCount, 6) },
                    },
                }
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();